/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import {
  Grid,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import './CancelLeaveModel.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalFooter from '../../CustomModal/ModalFooter';
import ModalHeader from '../../CustomModal/ModalHeader';
import { fonts, themes } from '../../../themes/themes';
import { DateField, DatePickerInput } from '../../../../components';
import {
  baseDateFormatting,
  convertUtcToDate,
  defaultDateFormatting,
} from '../../../helper';
import { leavesService } from '../../../../api/services/leavesService';
import {
  setAllLeaveApplied,
  setRefreshLeaveApplied,
} from '../../../../infra/aggregates/myProfile/leavesAggregates/leaveAppliedSlice';
import {
  setAllLeaveHistory,
  setRefreshLeaveHistory,
} from '../../../../infra/aggregates/myProfile/leavesAggregates/leaveHistorySlice';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';

interface ModalProps {
  isModalOpen?: boolean;
  leaveCancelData: any;
  closeModal: any;
  trans?: any;
}

const CancelLeaveModal = ({
  isModalOpen,
  leaveCancelData,
  closeModal,
  trans,
}: ModalProps) => {
  const dispatch = useAppDispatch();
  const selector = useAppSelector((state) => state);

  const [cancelWholeLeaves, setCancelWholeLeaves] = useState<boolean>(true);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [cancelPayload, setCancelPayload] = useState<any>(leaveCancelData);

  const handleCancelWholeLeaves = (e: any) => {
    const { checked } = e.target;
    setCancelWholeLeaves(checked);
    setCancelPayload({
      ...cancelPayload,
      cancel_whole_leave: checked,
    });
  };

  const handleFromDateChange = (fromDate: any) => {
    const payload = {
      ...cancelPayload,
      from_date: convertUtcToDate(fromDate, defaultDateFormatting, null, false),
    };
    setCancelPayload(payload);
  };
  const handleToDateChange = (toDate: any) => {
    const payload = {
      ...cancelPayload,
      to_date: convertUtcToDate(toDate, defaultDateFormatting, null, false),
    };
    setCancelPayload(payload);
  };

  const handleCancelLeave = () => {
    setIsSubmitting(true);
    dispatch(setRefreshLeaveApplied(true));
    leavesService.cancelLeave(cancelPayload).then((res: any) => {
      refreshFunction();
    });
  };

  const refreshFunction = async () => {
    const response = await leavesService.getEmployeeAppliedLeaves(
      selector.authSlice.company_id,
      selector.authSlice.emp_id,
    );
    if (response) {
      dispatch(setAllLeaveApplied(response.data));
    }
    dispatch(setRefreshLeaveApplied(false));

    dispatch(setRefreshLeaveHistory(true));
    const response_history = await leavesService.getEmployeeLeaveHistory(
      selector.authSlice.company_id,
      selector.authSlice.emp_id,
    );
    if (response_history) {
      dispatch(setAllLeaveHistory(response_history.data));
    }
    dispatch(setRefreshLeaveHistory(false));

    setIsSubmitting(false);
    closeModal();
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="800px"
      modalWidth="auto"
    >
      <ModalHeader
        modal={{ modal_title: trans('Leave Cancel') }}
        closeModal={closeModal}
      />
      <Grid
        container
        style={{
          marginTop: '35px',
          width: '500px',
        }}
      >
        <Grid item xs={100} className="left-grid">
          <Grid container style={{ padding: '10px' }}>
            <Grid item xs={100}>
              <Typography
                style={{
                  fontFamily: fonts.fontFamily,
                  fontSize: fonts.title,
                  color: themes.blackDefault,
                  fontWeight: 'bold',
                }}
              >
                {trans('Leave Cancel date')}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <div style={{ display: 'flex' }} className="mt-2">
                <div className="date-field ml" style={{ display: 'flex' }}>
                  <div className="ml">{trans('From')}</div>
                  :
                  <DateField
                    value={leaveCancelData.from_date}
                    format={baseDateFormatting}
                  />
                </div>
                <div className="date-field ml" style={{ display: 'flex' }}>
                  <div className="ml">{trans('To')}</div>
                  :
                  <DateField
                    value={leaveCancelData.to_date}
                    format={baseDateFormatting}
                  />
                </div>
              </div>
              <FormControlLabel
                label={trans('Cancel Whole Leave')}
                control={
                  <Checkbox
                    checked={cancelWholeLeaves}
                    onChange={(e: any) => handleCancelWholeLeaves(e)}
                  />
                }
              />
              <div
                style={{
                  display: `${cancelWholeLeaves ? 'none' : 'flex'}`,
                  marginTop: '2rem',
                }}
              >
                <div className="ml" style={{ width: '100%' }}>
                  <DatePickerInput
                    value={new Date(leaveCancelData.from_date)}
                    label={trans('From Date')}
                    width="100%"
                    onChange={(newValue: Date | string) => {
                      handleFromDateChange(newValue);
                    }}
                  />
                </div>
                <div className="ml" style={{ width: '100%' }}>
                  <DatePickerInput
                    value={new Date(leaveCancelData.to_date)}
                    label={trans('To Date')}
                    width="100%"
                    onChange={(newValue: Date | string) => {
                      handleToDateChange(newValue);
                    }}
                    minDate={cancelPayload.from_date}
                  />
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Box style={{ marginTop: '35px' }} />
      <ModalFooter
        onClickSubmit={() => handleCancelLeave()}
        onClickCancel={() => {
          closeModal();
        }}
        isSubmitButton={true}
        isSubmitting={isSubmitting}
      />
    </CustomModal>
  );
};

export default CancelLeaveModal;
